KMVP.kmcQuoteEditModal = {
    quoteId: '',
    quoteEntry: '',
    oldQuantity: '',
    bindQuantityChangeButton: function() {
        $(document).on('click', '.js-confirm-quote-line-item-edit', this.confirmQuantityChange.bind(this));
    },
    showEditModal: function(quoteEntryData) {
        var modal = $('.js-quote-line-item-edit-modal');
        modal.find('.js-quote-entry-description-data').text(quoteEntryData.description);
        modal.find('.js-quote-entry-domestic-data').text(quoteEntryData.domestic);
        if (quoteEntryData.dimensions) {
            modal.find('.js-quote-entry-dimensions-data').text(quoteEntryData.dimensions);
            modal.find('.js-quote-entry-dimensions-container').removeClass('hidden');
        } else {
            modal.find('.js-quote-entry-dimensions-container').addClass('hidden');
        }
        modal.find('.js-quote-edit-input-quantity').val(quoteEntryData.quantity);
        modal.find('.js-quote-edit-input-quantity-unit').html(quoteEntryData.unit);
        modal.modal('show');
        this.quoteId = quoteEntryData.quoteId;
        this.quoteEntry = quoteEntryData.entryLine;
        this.oldQuantity = quoteEntryData.quantity;
        KMVP.kmcQuoteEditModalValidation.hideErrorMessage();
    },
    hideEditModal: function() {
        $('.js-quote-line-item-edit-modal').modal('hide');
    },
    confirmQuantityChange: function() {
        var newQuantity = $('.js-quote-line-item-edit-modal .js-quote-edit-input-quantity').val();
        KMVP.kmcQuoteEditStorage.saveChange(this.quoteId, this.quoteEntry, this.oldQuantity, newQuantity);
    }
};

$(document).ready(function() {
    if ($('.js-kmc-quote-detail-page.js-kmc-quote-status-quote').length) {
        KMVP.kmcQuoteEditModal.bindQuantityChangeButton();
    }
});
